/**
 * Kontrahent uniwersalny dla połączonej listy „Dokumenty księgowe".
 * Analogicznie do przelewów (podmiot wpłacający / otrzymujący) prezentujemy
 * jednego kontrahenta zależnie od charakteru dokumentu:
 *   - faktura sprzedaży (KSeF, SubjectType 0) → nabywca,
 *   - faktura zakupu → sprzedawca,
 *   - rachunek → wystawca (rejestrowy = strona sprzedawcy).
 */

export interface InvoiceParty {
  name?: string;
  nip?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const resolveInvoiceContractor = (row: any): InvoiceParty => {
  // Sprzedaż KSeF: kontrahentem jest nabywca (identyfikator z węzła Buyer).
  const isSales = row?.SourceType === "K" && row?.SubjectType === 0;
  if (isSales) return { name: row?.Buyer?.Name, nip: row?.Buyer?.Identifier?.Value };
  // Zakup oraz rachunki/faktury rejestrowe: kontrahentem jest sprzedawca/wystawca.
  return { name: row?.Seller?.Name, nip: row?.Seller?.Nip };
};
